import { IconBadge } from "components/Icons";
import { Box, Button, IconButton } from "@mui/material";

import { useSnackbar } from "components/ToastMessage/useSnackbar";
import PropTypes from "prop-types";
import React, { useCallback, useMemo, useEffect } from "react";
import { getFocus, useAtom, useGet } from "state/jotai";
import { active_project, favorites as stateFavorites } from "state/store.global";
import { _project } from "state/store.projects";
import { useSendClick } from "hooks/fetch/useSendClick";

function ButtonFavorite({ unitId, iconOnly }) {
  const { showSnackbar } = useSnackbar();
  const [favorites, setFavorites] = useAtom(stateFavorites);
  
  const { pin, pid } = useGet(active_project);
  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? [];
  
  const sendClick = useSendClick();

  const isLiked = useMemo(() => favorites.includes(unitId), [favorites, unitId]);
  
  const heartempty = { icon: 'heart_empty', isFaIcon:false, color: clr?.heart_empty, size: "24px" };
  const heartfull = { icon: 'heart_full', isFaIcon:false, color: clr?.heart_full, size: "24px" };

  const handleClick = useCallback((e) => {
    e.stopPropagation();
    
    sendClick(isLiked ? "unit_favorite_removed" : "favorites_button", {
      unitID: unitId,
    });

    const toastMessage = isLiked 
      ? buttonsLabel?.find(btn => btn.UILabelProperty === "ToastRemovedforFavorites")?.Label
      : buttonsLabel?.find(btn => btn.UILabelProperty === "ToastAddedtoFavorites")?.Label;
    
    showSnackbar(toastMessage);
    
    setFavorites(prevFavorites => 
      prevFavorites.includes(unitId) 
        ? prevFavorites.filter((id) => id !== unitId)
        : [...prevFavorites, unitId]
    );
    
    log({ 
      action: isLiked ? 'removed_apartment_from_favorites' : 'added_apartment_to_favorites', 
      unitId 
    });
  }, [isLiked, buttonsLabel, unitId, showSnackbar, setFavorites]);

  const buttonLabels = useMemo(() => ({
    favorite: buttonsLabel?.find(btn => btn.UILabelProperty === 'Favorit')?.Label || 'Favorit',
    yourFavorite: buttonsLabel?.find(btn => btn.UILabelProperty === 'DinFavorit')?.Label || 'Din favorit'
  }), [buttonsLabel]);
  
  return (
    <>
      {iconOnly ? (
        <IconButton onClick={handleClick}>
          <IconBadge 
            {...(isLiked ? heartfull : heartempty)} 
            style={{ fontSize: "20px" }}
            className="icon-badge" 
            sx={{ fill: isLiked ? "#863E30" : `${clr?.primary_text}` }}
            size="sm"
          />
        </IconButton>
      ) : (
        <Button
          type="button"
          onClick={handleClick}
          color="inherit"
          disableRipple
          disableFocusRipple
          sx={{
            padding: 0,
            minWidth: 0,
            background: "none",
            boxShadow: "none",
            "&:hover": {
              background: "none",
            },
          }}
          startIcon={
            <IconBadge 
              {...(isLiked ? heartfull : heartempty)} 
              style={{ fontSize: "20px" }}
              className="icon-badge" 
              sx={{ color: isLiked ? "#863E30" : "inherit" }}
            />
          }
        >
          <Box
            component="span"
            sx={{
              whiteSpace: "nowrap",
            }}
            className="paragraph1-regular"
          >
            {isLiked ? buttonLabels.yourFavorite : buttonLabels.favorite}
          </Box>
        </Button>
      )}
    </>
  );
}

ButtonFavorite.propTypes = {
  unitId: PropTypes.number.isRequired,
  iconOnly: PropTypes.bool,
};

export default React.memo(ButtonFavorite);
